import {clearAllData, getSystemSettingList} from '@/api/get-data.js'

export default {
  name: 'login',
  data () {
    // 用户名校验
    let validateName = (rule, value, callback) => {
      let pattern = /^[a-zA-Z0-9_-]{4,16}$/
      if (value === '') {
        callback(new Error('请输入用户名'))
      } else {
        callback()
      }
      if (!pattern.test(value)) {
        callback(new Error('请检查用户名格式'))
      } else {
        callback()
      }
    }
    // 密码校验
    let validatePass = (rule, value, callback) => {
      let pattern = /^[^ ]+$/
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        callback()
      }
      if (!pattern.test(value)) {
        callback(new Error('请检查密码格式'))
      } else {
        callback()
      }
    }
    // 验证码校验
    let validateVerificationCode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入验证码'))
      } else {
        callback()
      }
    }
    return {
      rememberPassword: false,
      loginForm: {
        name: '',
        password: '',
        verificationCode: '',
        mode: this.$globalConfig.loginMode,
        appId: '',
        appSecret: ''
      },
      rules: {
        name: [ { validator: validateName, trigger: blur } ],
        password: [ { validator: validatePass, trigger: blur } ],
        verificationCode: [ { validator: validateVerificationCode, trigger: blur } ]
      },
      sendSmsVerificationCodeButtonText: '获取验证码',
      sendSmsVerificationCodeCountDown: 0,
      // 轮巡定时器
      pollingTimer: null
    }
  },
  mounted () {
    // 读取记住密码标识和上一次登录密码
    this.loginForm.name = this.$store.getters.userName
    this.rememberPassword = this.$store.getters.userRememberPassword
    if (this.$store.getters.userRememberPassword) {
      this.loginForm.password = this.$store.getters.userPassword
    }

    // 为通过输入合法性验证，为隐藏文本框设置默认内容
    if (this.loginForm.mode === 0) { // 密码登录
      this.loginForm.verificationCode = '123456'
    } else if (this.loginForm.mode === 1) { // 短信验证码登录
      this.loginForm.password = '111111'
    }
  },
  beforeDestroy() {
    // 停止轮巡
    this.stopPolling()
  },
  methods: {
    // 获取验证码
    sendSmsVerificationCode (formName) {
      this.$refs[formName].validateField('name', (errorString) => {
        if (!errorString) {
          if (this.sendSmsVerificationCodeCountDown > 0) { // 重发倒计时尚未结束
            return
          }

          this.$http(this.$api.sendSmsVerificationCode, {name: this.loginForm.name}).then(
            res => {
              if (res.code === 200) {
                this.startPolling() // 开始重发倒计时
                // this.loginForm.verificationCode = res.data.verificationCode
              }
            }
          )
        }
      })
    },
    // 提交登录请求
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http(this.$api.login, this.loginForm).then(
            res => {
              if (res.code === 200) {
                // 清除全部数据
                clearAllData()

                // 获取系统设定列表
                getSystemSettingList(() => {
                })

                //
                this.$store.commit('user/SET_TOKEN', res.data.accessToken)
                this.$store.commit('user/SET_NAME', this.loginForm.name)
                this.$store.commit('user/SET_PASSWORD', {password: this.loginForm.password, rememberPassword: this.rememberPassword})
                this.$store.commit('app/SET_HEADER_MENU_CURRENT_ITEM', this.$globalConfig.redirectPathAfterLogin)
                this.$router.push({path: this.$globalConfig.redirectPathAfterLogin})
              }
            }
          )
        }
      })
    },
    // 开始轮巡
    startPolling() {
      if (this.pollingTimer != null) {
        return
      }
      this.sendSmsVerificationCodeCountDown = 60
      this.pollingTimer = setInterval(() => {
        if (this.sendSmsVerificationCodeCountDown > 0) {
          this.sendSmsVerificationCodeButtonText = this.sendSmsVerificationCodeCountDown + '秒后重发'
          --this.sendSmsVerificationCodeCountDown
        }
        if (this.sendSmsVerificationCodeCountDown === 0) {
          this.sendSmsVerificationCodeButtonText = '获取验证码'
          this.stopPolling()
        }
      }, 1000)
    },
    // 停止轮巡
    stopPolling() {
      if (this.pollingTimer != null) {
        clearInterval(this.pollingTimer)
        this.pollingTimer = null
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/login/Login.js